import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { withQueryParams } from "../helpers/common.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "date-fns";
import "date-fns/locale";
import "fast-memoize";
import "../appointment-schedule.types.js";
import "react/jsx-runtime";
import "axios";
const getWorkingTimes = (axios) => async (params, signal) => {
  const { data = [] } = await axios.get("/api/v2/working-times", {
    signal,
    params
  });
  return data.map(({ employeeId: { referenceId: employeeReferenceId }, workingTimes, nonWorkingTimes }) => ({
    employeeReferenceId,
    workingTimes,
    nonWorkingTimes
  }));
};
const REFETCH_TIME = 30;
const useWorkingTimes = ({ clinicReferenceId, auth, baseURL, params: defaultParams }) => {
  var _a;
  const { shiftPlanner } = useAxiosProvider();
  const params = useMemo(
    () => {
      var _a2;
      return {
        ...defaultParams,
        employeeReferenceIds: (_a2 = defaultParams == null ? void 0 : defaultParams.employeeReferenceIds) == null ? void 0 : _a2.join(","),
        clinicReferenceId,
        useAvailabilityAsFallback: false
      };
    },
    [defaultParams, clinicReferenceId, auth]
  );
  const queryKey = ["working-times", params];
  const enabled = !!clinicReferenceId && !!auth && !!baseURL && !!(defaultParams == null ? void 0 : defaultParams.start) && !!((_a = defaultParams == null ? void 0 : defaultParams.employeeReferenceIds) == null ? void 0 : _a.length);
  const { data, ...queryResult } = useQuery({
    // @ts-expect-error TODO:
    queryKey,
    queryFn: withQueryParams(getWorkingTimes(shiftPlanner)),
    keepPreviousData: true,
    refetchInterval: REFETCH_TIME * (60 * 1e3),
    enabled
  });
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useWorkingTimes
};
